import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getFamilyFestFaqQuestionsByCategoryId = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/faq-questions/get-by-category-id', request);
};
const getFamilyFestFaqQuestionById = (id) => {
    return vdkEmHappinessPortalApi.get(`/family-fest/faq-questions/${id}`);
};
const createFamilyFestFaqQuestion = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/faq-questions', request);
};
const updateFamilyFestFaqQuestion = (request) => {
    return vdkEmHappinessPortalApi.put('/family-fest/faq-questions', request);
};
const deleteFamilyFestFaqQuestion = (id) => {
    return vdkEmHappinessPortalApi.delete(`/family-fest/faq-questions/${id}`);
};
const reorderFamilyFestFaqQuestions = (request) => {
    return vdkEmHappinessPortalApi.post('/family-fest/faq-questions/reorder', request);
};
const familyFestFaqQuestionApi = {
    getFamilyFestFaqQuestionsByCategoryId,
    getFamilyFestFaqQuestionById,
    createFamilyFestFaqQuestion,
    updateFamilyFestFaqQuestion,
    deleteFamilyFestFaqQuestion,
    reorderFamilyFestFaqQuestions
};
export default familyFestFaqQuestionApi;
